export default "__VITE_ASSET__43676f55__"